import React, { useContext } from "react";
import { Context } from "./index";

const MaterialSwitcher = () => {
  const {
    selectedImageName: selectedImageIndex,
    materialGroups,
    setSelectedImageName: setSelectedImageIndex,
    closeOverlay,
  } = useContext(Context);
  const handleMaterialClick = (index) => {
    setSelectedImageIndex(index);
    closeOverlay();
  };

  return (
    <div className="new-project-hotspot-pannellum-materials-switcher">
      <div className="new-project-hotspot-pannellum-materials-switcher-content">
        <div className="new-project-hotspot-pannellum-materials-switcher-content-types">
          {materialGroups
            .find((group) => group.find((g) => g.to === selectedImageIndex))
            .map((m) => {
              if (m.to === selectedImageIndex) return <></>;
              return (
                <span
                  className="new-project-hotspot-pannellum-materials-switcher-content-types__item"
                  onClick={() => handleMaterialClick(m.to)}
                >
                  {m.type}
                </span>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default MaterialSwitcher;
